import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {FormHelperService} from "../../../../../shared/services/form-helper.service";
import {merge, ReplaySubject} from "rxjs";
import {Contract} from "../../../../../shared/interface/contract";
import {first, skipUntil, takeUntil} from "rxjs/operators";
import {InvoiceDocumentService} from "../../../../../shared/services/invoice-document.service";
import {Uuid} from "../../../../../shared/interface/response/uuid";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-invoice-document-create',
  templateUrl: './invoice-document-create.component.html',
  styleUrls: ['./invoice-document-create.component.scss']
})
export class InvoiceDocumentCreateComponent implements OnInit, OnDestroy {
  disabledInvoiceNote = false;
  processingRequest = false;
  blockSubmit = false;
  invoiceNoteForm: FormGroup;
  companyControl: FormControl;
  contractControl: FormControl;
  grossControl: FormControl;
  reasonControl: FormControl;

  companyId: number | null = null;
  selectedContract?: Contract;

  errors: any = {};


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private snackBar: MatSnackBar,
    private invoiceDocumentService: InvoiceDocumentService,
    private router: Router,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
  ) {

    this.invoiceNoteForm = this.fb.group({
      company: this.companyControl = fb.control('', [Validators.required]),
      contract: this.contractControl = fb.control({ value: '', disabled: true }, [Validators.required]),
      gross: this.grossControl = fb.control('', [Validators.required]),
      reason: this.reasonControl = fb.control('', [Validators.required]),

    });
  }

  ngOnInit(): void {
    this.companyControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((company: any) => {
        this.companyId = company?.id ?? company?.uuid ?? company ?? null;

        this.contractControl.setValue('');
        this.selectedContract = undefined;

        if (this.companyId) {
          this.contractControl.enable();
        } else {
          this.contractControl.disable();
        }
      });
  }


  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  contractChanged(contract: Contract): void {
    this.selectedContract = contract;
  }

  save(): void {
    if (!this.invoiceNoteForm.valid) {
      this.invoiceNoteForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }
    this.disabledInvoiceNote = true;
    this.processingRequest = true;
    this.invoiceDocumentService.sendForm(this.invoiceNoteForm.value)
      .pipe(
        first()
      ).subscribe((response: Uuid) => {
      this.snackBar.open('Pomyślnie utworzono notę', '', {
        duration: 2000,
      });
      this.processingRequest = false;
      this.router.navigate(['/noty/szczegoly', response.uuid]);
    }, (error: HttpErrorResponse) => {
      this.disabledInvoiceNote = false;
      this.processingRequest = false;

      this.snackBar.open('Podczas przesyłania formularza wystąpił błąd', error.status.toString(), {
        duration: 2000,
      });

      if (error.status === 400) {
        this.errors = error.error.error.list;
        this.formHelper.setBackendErrorState(this.invoiceNoteForm, this.errors);
      }
    });


  }

  cancel(): void {
    this.router.navigate(['/noty']);
  }
}
